import { renderKoDataTable, renderKoEmptyState } from '~/components/templates/listPageDataTable';
import { renderRecruitingStatusCell, renderRecruitingTextCell } from '~/components/templates/recruiting/RecruitingTable';
import { html, LpButton, LpTable } from '~/design-system';
const columns = [
    { key: 'id', label: 'ID', width: 88, minWidth: 72, resizable: true },
    { key: 'name', label: 'Name', minWidth: 220, resizable: true },
    { key: 'channel', label: 'Channel', width: 160, minWidth: 128, resizable: true },
    { key: 'type', label: 'Type', width: 180, minWidth: 140, resizable: true },
    { key: 'live', label: 'Live', width: 128, minWidth: 104, resizable: true },
    { key: 'actions', label: 'Actions', align: 'center', width: 128, minWidth: 112, required: true },
];
export function renderTransmissionsTable() {
    return renderKoDataTable({
        title: 'Transmissions',
        titleIcon: 'paper-plane-tilt',
        caption: 'Lead transmissions',
        columns,
        className: 'transmissions-table',
        children: renderBody(),
    });
}
function renderBody() {
    return html `
        ${LpTable.Body({
        attributes: { 'data-bind': 'foreach: transmissions' },
        children: LpTable.Row({
            children: html `
                    ${renderRecruitingTextCell({ column: columns[0], binding: 'id' })}
                    ${renderRecruitingTextCell({ column: columns[1], binding: '$data.name || $data.label || ""', titleBinding: '$data.name || $data.label || ""' })}
                    ${renderRecruitingTextCell({ column: columns[2], binding: '$data.channelName || $data.channel || ""' })}
                    ${renderRecruitingTextCell({ column: columns[3], binding: '$data.transmissionTypeName || $data.typeName || $data.transmissionType || ""' })}
                    ${renderRecruitingStatusCell({
                column: columns[4],
                textBinding: '$data.liveLabel || (Number($data.live || 0) === 1 ? "Live" : "Paused")',
                cssBinding: `
                            'task-status--success': Number($data.live || 0) === 1,
                            'task-status--pending': Number($data.live || 0) !== 1
                        `,
            })}
                    ${LpTable.Cell({
                column: columns[5],
                children: html `
                            <div class="list-page-row-actions">
                                ${LpButton({ ariaLabel: 'Edit', prefixIcon: 'pencil-simple', size: 'sm', shape: 'square', variant: 'ghost', className: 'list-edit-action', attributes: { 'data-bind': 'click: $parent.onClickEdit' } })}
                                ${LpButton({ ariaLabel: 'Run', prefixIcon: 'play', size: 'sm', shape: 'square', variant: 'ghost', className: 'list-edit-action', attributes: { 'data-bind': 'click: $parent.onClickRun' } })}
                            </div>
                        `,
            })}
                `,
        }),
    })}
        ${renderKoEmptyState({ colSpan: columns.length, visibleBinding: 'transmissions().length === 0', title: 'No transmissions found', description: 'No transmissions match the selected filters.', icon: 'paper-plane-tilt' })}
    `;
}
